import editarTerminalCustomerForm from './editarTerminalFormModel';
const {
  formField: {
    // DATOS AREA
    name,
    description,
    typeTerminal,
  },
} = editarTerminalCustomerForm;

export default {
  [name.name]: '',
  [description.name]: '',
  [typeTerminal.name]: '',
};
